/// <reference path="../../../wwwroot/lib/devextreme/dist/ts/dx.all.d.ts" />
namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor('Matrix.Workflow.ClientFunctionInvocationHistoryGrid')
    @Serenity.Decorators.element("<div/>")
    export class ClientFunctionInvocationHistoryGrid extends SiteEntityGrid<ClientFunctionInvocationRow, any> {
        protected getColumnsKey() { return 'Workflow.ClientFunctionInvocationHistory'; }
        protected getDialogType() { return ClientFunctionInvocationDialog; }
        protected getIdProperty() { return ClientFunctionInvocationRow.idProperty; }
        protected getLocalTextPrefix() { return ClientFunctionInvocationRow.localTextPrefix; }
        protected getService() { return ClientFunctionInvocationService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            container.parents().find("div.category").append('<div class="field"><div id="history-sparkline"></div></div>');
        }

        getButtons() {
            return super.getButtons().filter(x => x.cssClass != "add-button");
        }

        getInitialTitle() {
            return null;
        }

        private _functionCode: string;

        public get functionName() {
            return this._functionCode;
        }

        public set functionName(value: string) {
   
            if (this._functionCode != value) {
                this._functionCode = value;
                this.setEquality(ClientFunctionInvocationRow.Fields.FunctionName, value);
                this.refresh();
            }
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.functionName;
        }

        getIncludeColumns(include) {
            super.getIncludeColumns(include);
            include[ClientFunctionInvocationRow.Fields.FunctionRerunnable] = true;
        }

        getColumns() {
            var columns = super.getColumns();

            columns.splice(0, 0, {
                field: 'Re-Run',
                name: '',
                width: 35,
                minWidth: 35,
                maxWidth: 35,
                format: ctx => {
                    if (!(ctx.item as ClientFunctionInvocationRow).FunctionRerunnable)
                        return "";

                    return `<a class="inline-action re-run" title="Re-trigger function"><i class="fa fa-repeat"></i></a>`;
                },
                headerFilterType: Serenity.HeaderFilterType.disabled
            });

            return columns;
        }

        protected markupReady() {
            super.markupReady();

            var data = this.getItems();

            $("#history-sparkline").dxChart({
                dataSource: data,
                argumentAxis: {
                    type: 'discrete',
                    tick: {
                        visible: false
                    }
                },
                valueAxis: {
                    title: {
                        text: 'Duration(ms)',
                        font: {
                            size: 10,
                            weight:500
                        }
                    }
                },
                commonSeriesSettings: {
                    argumentField: "InvocationId",
                    valueField: "DurationMs",
                    type: "bar"
                },
                series: [{}],
                legend: {
                    visible: false
                },
                customizePoint: function (pointInfo) {
                    if (pointInfo.data.StatusCode === "SUCCEEDED") {
                        return { color: "green" };
                    } else if (pointInfo.data.StatusCode === "FAILED") {
                        return { color: "red"};
                    } else if (pointInfo.data.StatusCode === "STARTED") {
                        return { color: "blue" };
                    }
                }
            });

        }

        protected onClick(e, row, cell) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as ClientFunctionInvocationRow;
            var target = $(e.target);
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();
                if (target.hasClass('re-run')) {
                    Q.confirm('Do you want to re-trigger this function?', () => {
                        ClientFunctionTriggerView.Invoke({
                            InvocationId: item.InvocationId
                        },
                            () => {
                                Q.notifyInfo("Re-triggering function " + item.FunctionName);
                                this.refresh();
                            }
                        );
                    });
                }
            }
        }
    }
}